import { LOVABLE_LICITACOES_URL } from '../lib/constants';

export default function Licitacoes() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 flex items-center justify-center bg-[#E8610A]/10 text-[#E8610A] rounded-xl">
          <i className="ri-auction-line text-lg"></i>
        </div>
        <div>
          <h2 className="font-bold text-gray-900">Licitações</h2>
          <p className="text-sm text-gray-500">
            Inteligência e gestão de licitações
          </p>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-200 p-8">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 flex items-center justify-center bg-[#1F2329] text-white rounded-xl shrink-0">
            <i className="ri-auction-line text-xl"></i>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-gray-900 text-lg mb-1">
              Sistema completo de licitações
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-6">
              Seu sistema de inteligência e gestão de licitações continua
              rodando de forma independente, com banco de dados e autenticação
              próprios. Aqui ele será integrado de forma definitiva por
              API/webhooks nas próximas etapas — por enquanto, o acesso é por
              link direto.
            </p>

            {LOVABLE_LICITACOES_URL ? (
              <a
                href={LOVABLE_LICITACOES_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#E8610A] text-white text-sm font-semibold px-5 py-3 rounded-xl hover:bg-[#C4500A] transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line"></i>
                Abrir sistema de licitações
              </a>
            ) : (
              <div className="inline-flex items-center gap-2 bg-gray-100 text-gray-400 text-sm font-semibold px-5 py-3 rounded-xl whitespace-nowrap">
                <i className="ri-plug-line"></i>
                Aguardando endereço do sistema
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-200 p-6">
        <h4 className="text-sm font-bold text-gray-900 mb-3 uppercase tracking-wider">
          Integração futura prevista
        </h4>
        <ul className="space-y-2 text-sm text-gray-600">
          {[
            'Licitação estratégica detectada → gerar oportunidade no CRM',
            'Licitação aprovada para participação → entrar no pipeline',
            'Licitação ganha → gerar projeto/contrato',
            'Empresa/órgão da licitação → relacionar à ficha 360º',
            'Valor potencial e margem → entrar no dashboard comercial',
          ].map((item) => (
            <li key={item} className="flex items-start gap-2">
              <i className="ri-arrow-right-circle-line text-[#E8610A] mt-0.5"></i>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}